<div class="js-with-4-levels with-4-levels box-content">
  <ul class="second-level">
    @for (secondLevel of node?.children; track secondLevel; let i = $index) {
      @if (secondLevel?.children?.length || secondLevel.url) {
        <li>
          <button
            class="js-btn-action btn-action"
            type="button"
            [ngClass]="{ 'is-active': i === 0 }"
            [attr.data-index]="i"
            (mouseenter)="setActiveContainer(i)"
            >
            <nav-label [node]="secondLevel" classContainer="label-second-level"></nav-label>
          </button>
        </li>
      }
    }
  </ul>

  @for (secondLevel of node?.children; track secondLevel; let i = $index) {
    <ul class="js-third-level second-to-last-level" [ngClass]="{ 'is-active': i === 0 }" [attr.data-index]="i">
      @for (thirdLevel of secondLevel?.children; track thirdLevel) {
        @if (thirdLevel?.children?.length || thirdLevel.url) {
          <li>
            <nav-label [node]="thirdLevel" classContainer="label-second-to-last-level"></nav-label>
            <ul class="last-level">
              @for (lastLevel of thirdLevel?.children; track lastLevel) {
                @if (lastLevel?.children?.length || lastLevel.url) {
                  <li>
                    <nav-label [node]="lastLevel" classContainer="label"></nav-label>
                  </li>
                }
              }
            </ul>
          </li>
        }
      }
    </ul>
  }
</div>
